import { Constant } from '../../../../../Helpers/constant';

const StatusFilter = ({ statusFilters, setAppliedName, appliedName, setAppliedAction, updateURLParams }) => {
  return (
    <>
      <div className="horizontal-scrollor status-badge-wrapper">
        <div className="status-badge-container ">
          {statusFilters?.map((filter, index) => {
            return (
              <div
                className={`status-badge ${filter?.name === appliedName?.name ? 'active' : ''}`}
                key={index}
                onClick={() => {
                  setAppliedName(filter);
                  setAppliedAction(null);
                  updateURLParams({ limit: Constant.TABLE_PAGE_SIZE, skip: 1 });
                }}
              >
                <p className="status-badge-text">{filter?.name}</p>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default StatusFilter;
